<mat-dialog-content style="height:900px; max-height: 900px;  " >
  
      <mat-horizontal-stepper #stepper   [linear]="selectedPaymentType === 'PO'">
  
        
        <mat-step [stepControl]="step1Control" [editable]="!paymentID">
            <ng-template matStepLabel>Select Payment Type</ng-template>
            <form [formGroup]="step1Control" class="step1-form"> 

            
            <mat-form-field >
              <mat-label>Select Payment Type</mat-label>
              <mat-select
                formControlName="paymentType"
                (selectionChange)="onSelectPaymentType($event.value)">
                <mat-option *ngFor="let opt of poOptions" [value]="opt.value">
                  {{ opt.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
           
            <mat-form-field
              *ngIf="selectedPaymentType"
              >
              <mat-label>Select Company</mat-label>
              <mat-select
                formControlName="company"
                (selectionChange)="onSelectCompany($event.value)">
                <mat-option *ngFor="let co of companyOptions" [value]="co.value">
                  {{ co.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="step1Control.get('company').hasError('  ')">
                You must choose a company
              </mat-error>
            </mat-form-field>
    
            <div *ngIf="selectedPaymentType == 'Consignment'&& selectedCompany; else poTable">
              <div style="display: flex">
                <div class="input-date-header">
                  <mat-date-range-input
                    [rangePicker]="picker"
                    style="background-color: #f7f7f7"
                  >
                    <input
                    name="sinceDate"
                    [(ngModel)]="sinceDate"
                    [ngModelOptions]="{ standalone: true }"
                      matStartDate
                      placeholder="Start date"
                      style="background-color: #f7f7f7"
                    />
                    <input
                    name="toDate"
                    [(ngModel)]="toDate"
                    [ngModelOptions]="{ standalone: true }"
                      matEndDate
                      placeholder="End date"
                      style="background-color: #f7f7f7"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
               <!--  <button
                  class="gts-btn-primary"
                  matRipple
                  (click)="getAllContactsFormByDate()"
                  [disabled]="sinceDate == null || searching"
                >
                  <span class="gts-btn-icon" *ngIf="!searching">search</span>
                  <i
                    class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
                    *ngIf="searching"
                  ></i>
                </button> -->
              </div>
            </div>

            <ng-template #poTable>
            <div *ngIf="selectedCompany" style="margin:1rem 0;">
              <h4>PO for {{ selectedCompany }}</h4>
              <ngx-skeleton-loader *ngIf="loading" count="10" appearance="line" animation="pulse"></ngx-skeleton-loader>
              <dinamic-table
              *ngIf="!loading"
              [id]="'popaymentTable'"
              [dbname]="'popayment'"
              [frontpaginate]="false"
              [data]="podata"
              [config]="options"
              [perPage]="itemsPorPagina"
              [page]="paginaActual"
              [total_items_count]="totalItems"
              [total_pages]="totalPaginas"
              (newConfig)="updateConfig($event)"
              [columnfilters]="filtros"
              (buscar)="getlistpo($event)"
              (rightClickAction)="handleRightClick($event)" 
              [bulk]="bulk"
          ></dinamic-table>
            </div>
          </ng-template>
             </form>
            <div class="firstubtton" style="text-align:right;">
             <!--  <button mat-button matStepperNext [disabled]="bulk.length <= 0"  (click)="posend()" >
                Next
              </button> -->
              <button
              class="gts-btn-primary-outline"
              style="font-size:smaller;"
              matRipple
              matStepperNext
              (click)="posend()"
              [disabled]=" (selectedPaymentType === 'PO' && bulk.length <= 0 ) ||
              (selectedPaymentType === 'Consignment' && toDate         == null)"
                    >
         
            <span class="gts-btn-text"> Next </span>
            <span class="gts-btn-icon-right">arrow_forward</span>
            </button>
            </div>
          </mat-step>
  
          <mat-step [stepControl]="step2Control">
            <form [formGroup]="step2Control" class="step2-form">
              <ng-template *ngIf="selectedPaymentType === 'PO'" matStepLabel>Equipment Receipt Verification</ng-template>
              <ng-template *ngIf="selectedPaymentType === 'Consignment'" matStepLabel>Recoverered Revenue Report</ng-template>

              <ng-container *ngIf="selectedPaymentType === 'Consignment'; else poReceipt">
                <app-multi-files
                  [idfather]="paymentID"
                  [type]="notesType"
                  (total)="onFilesTotalChanged($event)"
                   >
                </app-multi-files>
              </ng-container>

              <ng-template #poReceipt>
              <h2 class="po-header">PO# {{ bulkPoList }}</h2>
              <p class="question">
                Has the equipment been received?
              </p>
              <div class="yes-no">
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step2Control.get('received').value !== 'yes',
                  'gts-btn-primary': step2Control.get('received').value === 'yes'
                }"
                  type="button"
                  (click)="step2Control.get('received').setValue('yes')">
                  YES
                </button>
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step2Control.get('received').value !== 'no',
                  'gts-btn-primary': step2Control.get('received').value === 'no'
                }"
                  type="button"
                  (click)="step2Control.get('received').setValue('no')">
                  NO
                </button>
              </div>
              <mat-error *ngIf="step2Control.get('received').hasError('  ')">
                Please select an option
              </mat-error>
          
              <div *ngIf="step2Control.value.received === 'no'" style="margin-top:1rem">
                <mat-form-field   class="full-width">
                  <mat-label>
                    Please provide justification for upfront payment
                  </mat-label>
                  <textarea
                    matInput
                    rows="3"
                    formControlName="comment">
                  </textarea>
                  <mat-error *ngIf="step2Control.get('comment').hasError('  ')">
                    Comment is    to proceed
                  </mat-error>

                </mat-form-field>
              </div>
            </ng-template>
            <div class="actions">
          
              <button
              class="gts-btn-primary-outline"
              style="font-size:smaller;"
              matRipple
              matStepperPrevious
              [disabled]="!!paymentID"
                    >
         
                 
            <span class="gts-btn-text"> Previous </span>
            </button>
            <button
            class="gts-btn-primary"
            style="font-size:smaller;"
            matRipple
            (click)="Savedcosigmentbyid()"
            [disabled]="saving"
                  >
          <span class="gts-btn-icon-left">save</span>
          <span class="gts-btn-text"> Save </span>
          <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
          </button>
              <button
              class="gts-btn-primary-outline"
              style="font-size:smaller;"
              matRipple
              matStepperNext
              [disabled]=" (selectedPaymentType === 'PO' && !step2Control.valid) ||
              (selectedPaymentType === 'Consignment' && filesCount === 0)  || (saving) "
             >
                    
                   <!--  [disabled]="!step2Control.valid || filesCount === 0" -->
            <span class="gts-btn-text"> Next </span>
            <span class="gts-btn-icon-right"  *ngIf="!saving">arrow_forward</span>
            <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
            </button>
          </div>
        </form>
          </mat-step>
  
        
          <mat-step *ngIf="selectedPaymentType==='PO'" [stepControl]="step3Control">
           
            <form [formGroup]="step3Control" class="step3-form">
              <ng-template matStepLabel>
                Equipment Testing and QTY Confirmation
              </ng-template>
          
              <h2 class="po-header">PO# {{ bulkPoList }}</h2>
              <p class="question">
                Has the equipment been tested and quantities confirmed?
              </p>
          
              <div class="yes-no">
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step3Control.get('tested').value !== 'yes',
                  'gts-btn-primary': step3Control.get('tested').value === 'yes'
                }"
                  type="button"
                  (click)="step3Control.get('tested').setValue('yes')">
                  YES
                </button>
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step3Control.get('tested').value !== 'no',
                  'gts-btn-primary': step3Control.get('tested').value === 'no'
                }"
                  type="button"
                  (click)="step3Control.get('tested').setValue('no')">
                  NO
                </button>
              </div>
              <mat-error *ngIf="step3Control.get('tested').hasError('  ')">
                Please select an option
              </mat-error>
          
              <div *ngIf="step3Control.value.tested === 'no'" style="margin-top:1rem">
                <mat-form-field   class="full-width">
                  <mat-label>
                    Please provide justification for upfront payment
                  </mat-label>
                  <textarea
                    matInput
                    rows="3"
                    formControlName="testComment">
                  </textarea>
                  <mat-error *ngIf="step3Control.get('testComment').hasError('  ')">
                    Comment is    to proceed
                  </mat-error>
                </mat-form-field>
              </div>
         
          <div class="actions">
          
            <button
            class="gts-btn-primary-outline"
            style="font-size:smaller;"
            matRipple
            matStepperPrevious
                  >
       
                  <span class="gts-btn-icon-left">  arrow_back</span>
          <span class="gts-btn-text"> Previous </span>
          </button>
          <button
          class="gts-btn-primary"
          style="font-size:smaller;"
          matRipple
          (click)="Savedcosigmentbyid()"
          [disabled]="saving"
                >
        <span class="gts-btn-icon-left">save</span>
        <span class="gts-btn-text"> Save </span>
        <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
        </button>
            <button
            class="gts-btn-primary-outline"
            style="font-size:smaller;"
            matRipple
            matStepperNext
            [disabled]="step3Control.invalid || saving"
                  >
       
          <span class="gts-btn-text"> Next </span>
          <span class="gts-btn-icon-right"  *ngIf="!saving">arrow_forward</span>
          <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
          </button>
        </div>
      </form>
        </mat-step>
  
  
        <mat-step  [stepControl]="step4Control">
            <ng-template matStepLabel>Payment Processing</ng-template>
            <form [formGroup]="step4Control" class="step4-form">
                <ng-template matStepContent>
                  <ng-container *ngIf="selectedPaymentType==='PO'; else consignmentHeader">
              <h2 class="po-header">PO# {{ bulkPoList }}</h2>
            </ng-container>
            <ng-template #consignmentHeader>
              <div class="consignment-header">
                <h2 class="po-header">{{ selectedPaymentType }}</h2>
                <p class="date-range">
                  {{ sinceDate | date:'MM/dd/yyyy' }} – {{ toDate | date:'MM/dd/yyyy' }}
                </p>
              </div>
            </ng-template>

              <div class="po-cards-container">
                <div 
                  *ngFor="let item of bulkDetails; trackBy: trackById" 
                  class="po-card"
                >
                  
                  <span class="po-card-title">PO# {{ item.po }}</span>
                  <span class="po-card-amount">
                    {{ item.amount | currency:'USD':'symbol':'1.2-2' }}
                  </span>
                </div>
          
                <div class="po-card total-card">
                  <span class="po-card-title">Total  <span class="gts-btn-icon-right">payments</span></span>
                  <span class="po-card-amount">{{ selectedPaymentType==='Consignment'
               ? (step4Control.get('paymentAmount').value | currency:'USD':'symbol':'1.2-2')
               : bulkTotal }}</span>
                </div>
              </div>
              <div class="payment-inputs">
  
               
                <div class="amount-box">
                  <mat-form-field>
                    <mat-label >  <span class="campo-obligatorio">*</span>$ Enter the amount</mat-label>
                    <input
                      matInput
                      (change)="onAmountChanged($event)"
                      type="number"
                      formControlName="paymentAmount"
                      min="0"
                    >
                    <div matSuffix class="percent-buttons" *ngIf="selectedPaymentType==='PO'">
                      <button type="button" mat-button (click)="setPercent(1)">100%</button>
                      <button type="button" mat-button (click)="setPercent(0.75)">75%</button>
                      <button type="button" mat-button (click)="setPercent(0.5)">50%</button>
                      <button type="button" mat-button (click)="setPercent(0.25)">25%</button>
                    </div>
                  </mat-form-field>
                  <mat-error *ngIf="showAmountError && selectedPaymentType==='PO'">
                    The amount to pay must be equal to or less than the total amount.
                  </mat-error>
                </div>
              
                
                <div class="urgency-box">
                  <mat-form-field >
                    <mat-label>   <span class="campo-obligatorio">*</span>Payment Urgency</mat-label>
                    <mat-select formControlName="paymentUrgency">
                      <mat-option value="ASAP">ASAP</mat-option>
                      <mat-option value="Next Payment Run">Next payment run</mat-option>
                      <mat-option value="SpecificDate">Specific date</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div *ngIf="step4Control.value.paymentUrgency === 'SpecificDate'" class="specific-date-box">
                    <mat-form-field class="full-width">
                      <mat-label>   <span class="campo-obligatorio">*</span> Payment Date</mat-label>
                      <input
                        matInput
                        [matDatepicker]="specPicker"
                        formControlName="specificDate">
                      <mat-datepicker-toggle matSuffix [for]="specPicker"></mat-datepicker-toggle>
                      <mat-datepicker #specPicker></mat-datepicker>
                      <mat-error *ngIf="step4Control.get('specificDate')!.hasError('  ')">
                        Date is   
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              
              </div>
              <h4>Select Payment Method : </h4>
              <mat-tab-group class="payment-method-tabs" animationDuration="0ms"   (selectedTabChange)="onMethodTabChange($event.index)">
               
                <mat-tab label="Check – Pick-up">
                    <div class="check-tab" style=" margin: 10px "  >
                  
                      
                      <mat-form-field class="Paymentform"  >
                        <mat-label> Invoice number (if available) </mat-label>
                        <input    (wheel)="$event.target.blur()"  matInput formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                  
                      
                      <div class="counter" style=" margin:5px"  >
                        <button mat-mini-fab (click)="decrementChecks()" style=" background: #9c27b0; width: 25px; height: 25px ;" >
                          <mat-icon>remove</mat-icon>
                        </button>
                        <span style="font-size: 20px; margin: 1px;" class="count">{{ step4Control.get('numberOfChecks').value }}</span>
                        <button mat-mini-fab (click)="incrementChecks()" style=" background: #9c27b0; width: 25px; height: 25px ;" >
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>
                  
                      
                      <div formArrayName="checks" class="checks-list">
                        <div
                          *ngFor="let chk of checks.controls; let i = index; trackBy: trackById"
                          [formGroupName]="i"
                          class="check-entry">
                  
                          <mat-form-field  >
                            <mat-label> <span class="campo-obligatorio">*</span>Check payable to</mat-label>
                            <input matInput     formControlName="payableTo">
                          </mat-form-field>
                  
                          <mat-form-field  >
                            <mat-label> <span class="campo-obligatorio">*</span>Check amount</mat-label>
                            <input matInput     formControlName="amount" type="number" min="0.01">
                          </mat-form-field>
                        <hr>
                        </div>
                      </div>
                  
                      
                      <mat-form-field  >
                        <mat-label>   <span class="campo-obligatorio">*</span>Tentative date/time for vendor pick-up</mat-label>
                        <input
                          matInput    
                          [matDatepicker]="picker"
                          formControlName="pickupDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                  
                    </div>
                  </mat-tab>
                  <mat-tab label="Check – Mailed">
                    <div  class="check-tab" style="margin:10px">
                
                      
                      <mat-form-field  >
                        <mat-label>Invoice number (if available)</mat-label>
                        <input matInput  (wheel)="$event.target.blur()"    formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                
                      
                      <div class="counter" style="margin:5px">
                        <button mat-mini-fab (click)="decrementChecks()" style=" background: #9c27b0; width: 25px; height: 25px ;" >
                          <mat-icon>remove</mat-icon>
                        </button>
                        <span class="count">{{ step4Control.get('numberOfChecks').value }}</span>
                        <button mat-mini-fab (click)="incrementChecks()" style=" background: #9c27b0; width: 25px; height: 25px ;" >
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>
                
                      
                      <div formArrayName="checks" class="checks-list">
                        <div
                          *ngFor="let chk of checks.controls; let i = index; trackBy: trackById"
                          [formGroupName]="i"
                          class="check-entry">
                
                          <mat-form-field >
                            <mat-label>  <span class="campo-obligatorio">*</span>Check payable to</mat-label>
                            <input matInput     formControlName="payableTo">
                          </mat-form-field>
                
                          <mat-form-field >
                            <mat-label>  <span class="campo-obligatorio">*</span>Check amount</mat-label>
                            <input matInput     formControlName="amount" type="number" min="0.01">
                          </mat-form-field>
                          <hr>
                        </div>
                      </div>
                
                      
                      <mat-form-field >
                        <mat-label>  <span class="campo-obligatorio">*</span>Shipping address</mat-label>
                        <input matInput     formControlName="shippingAddress" placeholder="12345 Main St, City, ST ZIP">
                      </mat-form-field>
                
                     
                      <mat-form-field>
                        <mat-label>  <span class="campo-obligatorio">*</span>Select Shipping Method</mat-label>
                        <mat-select formControlName="shippingMethod">
                          <mat-option *ngFor="let opt of shippingOptions" [value]="opt.value">
                            {{ opt.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                
                    </div>
                  </mat-tab>
                <mat-tab label="ACH-Domestic"> 
                  <mat-form-field  >
                    <mat-label>Invoice number (if available)</mat-label>
                    <input matInput    (wheel)="$event.target.blur()"  formControlName="invoiceNumber" type="number">
                  </mat-form-field>
                  <div class="method-toggle">
                    <mat-slide-toggle
                      [checked]="modeACH === 'manual'"
                      (change)="setModeACH('manual')"
                    >
                      Add Info Manually
                    </mat-slide-toggle>
                  
                    <mat-slide-toggle
                      [checked]="modeACH === 'file'"
                      (change)="setModeACH('file')"
                    >
                      Add a File
                    </mat-slide-toggle>
                  </div>
                  
                
                
                  <ng-container *ngIf="modeACH === 'manual'">
                  
                    <mat-form-field  >
                      <mat-label>  <span class="campo-obligatorio">*</span>Beneficiary name</mat-label>
                      <input matInput     formControlName="Benefiname">
                    </mat-form-field>
                    <mat-form-field  >
                      <mat-label>  <span class="campo-obligatorio">*</span>Routing Number</mat-label>
                      <input matInput    formControlName="routingname" type="number" >
                    </mat-form-field>
                    <mat-form-field  >
                      <mat-label>  <span class="campo-obligatorio">*</span>Account Number</mat-label>
                      <input matInput    formControlName="accountnumber" type="number" >
                    </mat-form-field>
                  </ng-container>
                
                 
                  <ng-container *ngIf="modeACH === 'file'">
                    <app-multi-files
                    [idfather]="paymentID"
                    [type]="notesType"
                    (total)="onFilesTotalChanged($event)"
                     >
                  </app-multi-files>
                  </ng-container>
          
                  <!-- <mat-form-field  >
                        <mat-label>Invoice number (if available)</mat-label>
                        <input matInput     formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>Beneficiary name</mat-label>
                        <input matInput     formControlName="Benefiname">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>Routing Number</mat-label>
                        <input matInput    formControlName="routingname" type="number" >
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>Account Number</mat-label>
                        <input matInput    formControlName="accountnumber" type="number" >
                      </mat-form-field> -->
                </mat-tab>
                <mat-tab label="WT - International">
                  <mat-form-field  >
                    <mat-label>Invoice number (if available)</mat-label>
                    <input matInput   (wheel)="$event.target.blur()"  formControlName="invoiceNumber" type="number">
                  </mat-form-field>
                  <div class="method-toggle">
                    <mat-slide-toggle
                      [checked]="WTINTER === 'manual'"
                      (change)="setWTIN('manual')"
                    >
                      Add Info Manually
                    </mat-slide-toggle>
                  
                    <mat-slide-toggle
                      [checked]="WTINTER === 'file'"
                      (change)="setWTIN('file')"
                    >
                      Add a File
                    </mat-slide-toggle>
                  </div>

                  <ng-container *ngIf="WTINTER === 'manual'">

                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Beneficiary name</mat-label>
                        <input matInput    formControlName="Benefiname">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Beneficiary address</mat-label>
                        <input matInput    formControlName="Benefiaddr">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>CLABE (Account Number)</mat-label>
                        <input matInput    formControlName="accountNwt" type="number" >
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>SWIFT (Bank Code)</mat-label>
                        <input matInput    formControlName="swiftbankcode" type="number" >
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="WTINTER === 'file'">
                      <app-multi-files
                      [idfather]="paymentID"
                      [type]="notesType"
                      (total)="onFilesTotalChanged($event)"
                       >
                    </app-multi-files>
                    </ng-container>
                </mat-tab>
                <mat-tab label="WT - Domestic">
                    <mat-form-field  >
                        <mat-label>Invoice number (if available)</mat-label>
                        <input matInput   (wheel)="$event.target.blur()"  formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                      <div class="method-toggle">
                        <mat-slide-toggle
                          [checked]="WTDOME === 'manual'"
                          (change)="setWTDOME('manual')"
                        >
                          Add Info Manually
                        </mat-slide-toggle>
                      
                        <mat-slide-toggle
                          [checked]="WTDOME === 'file'"
                          (change)="setWTDOME('file')"
                        >
                          Add a File
                        </mat-slide-toggle>
                      </div>

                      <ng-container *ngIf="WTDOME === 'manual'">
                      
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Beneficiary name</mat-label>
                        <input matInput    formControlName="Benefinamewtdome">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Beneficiary address</mat-label>
                        <input matInput    formControlName="Benefiaddrwtdome">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Account Number</mat-label>
                        <input matInput    formControlName="accountNwtdo" type="number" >
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Routing Number</mat-label>
                        <input matInput    formControlName="routingnumberwtdo" type="number" >
                      </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="WTDOME === 'file'">
                      <app-multi-files
                      [idfather]="paymentID"
                      [type]="notesType"
                      (total)="onFilesTotalChanged($event)"
                       >
                    </app-multi-files>
                    </ng-container>

                </mat-tab>
                <mat-tab label="PayPal"> 
                    <mat-form-field  >
                        <mat-label>Invoice number (if available)</mat-label>
                        <input matInput  (wheel)="$event.target.blur()"   formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Customer email</mat-label>
                        <input matInput    formControlName="emailpaypal" type="email" >
                      </mat-form-field>
                 </mat-tab>
                <mat-tab label="Credit Card"> 
                    <mat-form-field  >
                        <mat-label>Invoice number (if available)</mat-label>
                        <input matInput   (wheel)="$event.target.blur()"  formControlName="invoiceNumber" type="number">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>AR departament contact</mat-label>
                        <input matInput    formControlName="ARdepartament">
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>Phone number</mat-label>
                        <input matInput    formControlName="phonecredit" type="number" >
                      </mat-form-field>
                      <mat-form-field  >
                        <mat-label>  <span class="campo-obligatorio">*</span>AR department email</mat-label>
                        <input matInput    formControlName="deparmentAR" type="email" >
                      </mat-form-field>
                </mat-tab>
              </mat-tab-group>
              
              <div class="actions">
             
          
                  <button
                  class="gts-btn-primary-outline"
                  style="font-size:smaller;"
                  matRipple
                  matStepperPrevious
                        >
             
                        <span class="gts-btn-icon-left">  arrow_back</span>
                <span class="gts-btn-text"> Previous </span>
                </button>
                <button
                class="gts-btn-primary"
                style="font-size:smaller;"
                matRipple
                (click)="Savedcosigmentbyid()"
                [disabled]="saving"
                      >
              <span class="gts-btn-icon-left">save</span>
              <span class="gts-btn-text"> Save </span>
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
              </button>
                  <button
                  class="gts-btn-primary-outline"
                  style="font-size:smaller;"
                  matRipple
                  matStepperNext
                  [disabled]="step4Control.invalid || saving || isFileRequiredButNotUploaded()"
                        >
             
                <span class="gts-btn-text"> Next </span>
                <span class="gts-btn-icon-right"  *ngIf="!saving">arrow_forward</span>
                <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw" *ngIf="saving"></i>
                </button>
            
              </div>
            </ng-template>
          </form>
          </mat-step>
          <mat-step >
            <ng-template matStepLabel>Additional Notes(Optional)</ng-template>
            <h2  *ngIf="selectedPaymentType==='PO'" class="po-header">
                PO# {{ bulkPoList }}
              </h2>
              <form [formGroup]="step5Control" class="step5-form">
              <mat-form-field  >
                <mat-label>Additional Notes(Optional)</mat-label>
                <input matInput formControlName="test" type="text" >
              </mat-form-field>
            </form>
              <div class="actions">
                <!-- <button mat-button  >
                    Save
                  </button> -->
                  <button
                  class="gts-btn-primary-outline"
                  style="font-size:smaller;"
                  matRipple
                  matStepperPrevious
                        >
             
                        <span class="gts-btn-icon-left">  arrow_back</span>
                <span class="gts-btn-text"> Previous </span>
                </button>
                <button   class="gts-btn-primary-outline"matRipple  (click)="submitforanypayment()"  style="font-size:smaller;" [disabled]="submitting">
                  <span class="gts-btn-text" *ngIf="!submitting">Submit</span>
   
                  <i
                    class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
                    *ngIf="submitting"
                  ></i>
                </button>
              </div>
        </mat-step>
  
      </mat-horizontal-stepper>
 
  </mat-dialog-content>
  